import { ReactComponent as ETRExclamationTriangle } from "@/assets/svgs/etr-exclamation-triangle.svg";
import { ReactComponent as IconChevronDown } from "@/assets/svgs/chevron-down.svg";
import { ReactComponent as IconInfoCircle } from "@/assets/svgs/infoCircle.svg";
import { ReactComponent as IconFileUpload } from "@/assets/svgs/etr-file-upload-icon.svg";
import { ReactComponent as IconSearch } from "@/assets/svgs/icon-search.svg";
import { ReactComponent as IconCloseGrey } from "@/assets/svgs/iconCloseGrey.svg";
import { ReactComponent as IconNoMessage } from "@/assets/svgs/no-message.svg";
import { ReactComponent as IconFileNameEdit } from "@/assets/svgs/record-transfer-edit-icon.svg";
import { ReactComponent as IconWarningIndicator } from "@/assets/svgs/warning-indicator.svg";
import Button from "@/components/Button/index";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import MultiLevelDropDown from "@/components/MultiLevelMenuDropDown/index.js";
import Toast from "@/components/Toast/index";
import toastType from "@/constants/toast-type/index";
import useDataPage from '@/hooks/use-data-page/index';
import useEtrDocument from "@/hooks/use-etr-document/index";
import useModal from "@/hooks/use-modal/index";
import getPageLabel from "@/hooks/use-page-details/index";
import useToast from "@/hooks/use-toast";
import { useNavigate } from "@/lib/router-dom";
import api from '@/services/api/etr.js';
import rem from "@/utils/rem";
import { produce } from 'immer';
import moment from "moment";
import PropTypes from "prop-types";
import { useCallback, useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import { useDropzone } from 'react-dropzone';
import { useSelector } from "react-redux";
import FilterApplied from "../../../components/DataTable3/FilterApplied/index";
import ETRFilterDropDown from "./etr-filter-dropdown.jsx";
import { feature, features } from "@/utils/feature-verifier";
import Search from '@/componentsDS/Search/index';
import GetETRMakerCheckerStatus from '@/utils/etr-maker-checker-status'
import StatusTags, { STATUS } from '@/componentsDS/Tags/StatusTags';
import Tags from '@/componentsDS/Tags/Tags';
import { featureConstant } from "@/constants/configuration/feature.js";

const ETRIssuanceComponent = ({
    defaultFileLists = [],
    defaultSelectedItems = []
}) => {

    const [searchText, setSearchText] = useState("");
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [displayedSearchText, setDisplayedSearchText] = useState('');
    const [updatedData, setUpdatedData] = useState([])
    const [selectedItemsCount, setSelectedItemsCount] = useState(defaultSelectedItems);
    const { profile } = useSelector(state => state.auth)

    const [refreshData, setRefreshData] = useState(false);
    const [filter, setFilter] = useState({});

    const [currentPage, setCurrentPage] = useState(1);
    const { toastList, addToastMessage } = useToast();

    const pageLimit = 10;
    const { goTo } = useNavigate();

    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState(defaultFileLists)

    const [name, setName] = useState("");
    const [selectedTransferableRecordId, setSelectedTransferableRecordId] = useState(null);
    const [mouseDragActive, setMouseDragActive] = useState(false);

    const { ETRDataElements, contracts } = useSelector((state) => state.staticData.data);
    const {
        visible: updateTransactionModal,
        show: showUpdateTransactionModal,
        hide: hideUpdateTransactionModal,
    } = useModal();

    const {
        visible: deleteTransactionModal,
        show: showDeleteTransactionModal,
        hide: hideDeleteTransactionModal,
    } = useModal();

    const {
        visible: invalidErrorModal,
        show: showInvalidErrorModal,
        hide: hideInvalidErrorModal,
    } = useModal();

    const {
        visible: invalidFileUpload,
        show: showInvalidFileUpload,
        hide: hideInvalidFileUpload,
    } = useModal();

    const {
        visible: issuanceNotAllowdeModal,
        show: showIssuanceNotAllowedModal,
        hide: hideIssuanceNotAllowedModal,
    } = useModal();


    const [etrExistingDetails, setETRExistingDetails] = useState({});

    const { fetchEtrDocumentList, etrDocList, etrDocErrorMsg, meta, etrDocListLoading } = useEtrDocument();
    const isETRIGPNITRV5FeatureEnabled = feature(featureConstant?.ETR_IGPNI_TR_V5);
    const isETRLegalRequirementsEnabled = feature(featureConstant.IG_PNI_LEGAL_REQUIREMENTS);

    useEffect(() => {
        addToastMessage(etrDocErrorMsg, toastType.error);
    }, [etrDocErrorMsg]);

    useEffect(() => {
        const updatedItem = etrDocList?.map(field => ({ ...field, $selected: false }))
        setUpdatedData(updatedItem);
    }, [etrDocList]);

    useEffect(() => {
        if (updatedData?.length > 0) {
            setSelectedItemsCount(updatedData.filter(field => field.$selected === true).map(field => field.transferableRecordId));
        }
    }, [updatedData]);

    /*=================================================
        Sort
    /================================================*/
    const { sortConfig, handleSort } = useDataPage(
        {
            initialSortConfig: { key: "modified", direction: false },
        }
    );

    function getClassName(name) {
        if (!sortConfig) {
            return;
        }
        return sortConfig.key === name
            ? sortConfig.direction === true
                ? "is-asc"
                : "is-desc"
            : "";
    }

    /*=================================================
        Error Modal
    /================================================*/
    const [error, setError] = useState("")

    function handleError() {
        setError("");
        hideInvalidErrorModal();
    }

    useEffect(() => {
        if (error) {
            showInvalidErrorModal();
        }
    }, [error]);

    const refetchData = (page = currentPage) => {
        const params = {
            page: page,
            limit: 10,
            sortOrder: (sortConfig.direction === true ? "ASC" : "DESC"),
            sortBy: sortConfig.key,
            searchBy: searchText
        };
        if (filter?.documentType) {
            params.type = filter?.documentType.filter(s => s.$selected).map(s => s.id)
        }
        if (filter?.statusType) {
            params.status = filter?.statusType.filter(s => s.$selected).map(s => s.id)
        }
        if (filter?.startDate) {
            params.dateFrom = filter?.startDate
        }
        if (filter?.endDate) {
            params.dateTo = filter?.endDate
        }
        setCurrentPage(page);
        fetchEtrDocumentList(params);
    }

    useEffect(() => {
        refetchData();
    }, [currentPage, filter, sortConfig, refreshData]);

    // Search
    const handleSearch = (value) => {
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }
        setSearchTimeout(
            setTimeout(() => {
                setCurrentPage(1);
                setSearchText(value);
                setFilter({
                    ...filter,
                    'search': value,
                })
            }, 500)
        );
    };

    // Reset Filter
    function resetFilter() {
        setFilter({
            'search': filter?.search,
        });
        setCurrentPage(1)
        setRefreshData(!refreshData)
    }

    // Get ETR Maker Checker Event Status for Tooltip
    function getETRMakerCheckerEventStatus(status, itemStatus) {
        switch (itemStatus) {
            case "issuance_approved":
                return (
                    (status === "draft" && <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Record issuance was unsuccessful</span>
                        </div>
                    </div>)
                );
            case "issuance_rejected":
                return (
                    (status === "draft" && <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Record issuance was denied</span>
                        </div>
                    </div>)
                );
            case "restore_approved": case "shredding_approved":
                return (
                    (status === "surrendered" && <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Record Shredding Rejection was unsuccessful</span>
                        </div>
                    </div>)
                );
            case "restore_rejected": case "shredding_rejected":
                return (
                    (status === "surrendered" && <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Record Shredding Rejection was denied</span>
                        </div>
                    </div>)
                );
            case "owner_transfer_failed": case "endorsement_failed":
                return (
                    <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Ownership transfer was unsuccessful</span>
                        </div>
                    </div>
                );
            case "owner_transfer_rejected": case "endorsement_rejected":
                return (
                    <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Ownership transfer was denied</span>
                        </div>
                    </div>
                );
            case "holder_transfer_failed":
                return (
                    <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Holdership transfer was unsuccessful</span>
                        </div>
                    </div>
                );
            case "holder_transfer_rejected":
                return (
                    <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Holdership transfer was denied</span>
                        </div>
                    </div>
                );
            case "owner_holder_transfer_failed":
                return (
                    <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Ownership & Holdership transfer was unsuccessful</span>
                        </div>
                    </div>
                );
            case "owner_holder_transfer_rejected":
                return (
                    <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Ownership & Holdership transfer was denied</span>
                        </div>
                    </div>
                );
            case "owner_holder_transfer_rejection_rejected":
                return (
                    <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Ownership & Holdership Rejection transfer was denied</span>
                        </div>
                    </div>
                );
            case "holder_transfer_rejection_rejected":
                return (
                    <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Holdership Rejection transfer was denied</span>
                        </div>
                    </div>
                );
            case "owner_transfer_rejection_rejected":
                return (
                    <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Ownership Rejection transfer was denied</span>
                        </div>
                    </div>
                );
            case "nomination_failed":
                return (
                    <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Ownership nomination was unsuccessful</span>
                        </div>
                    </div>
                );
            case "nomination_rejected":
                return (
                    (status != "surrendered" && <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>Ownership nomination was denied</span>
                        </div>
                    </div>)
                );
            case "surrender_failed": case "surrender_approved":
                return (
                    (status === "surrender_failed" && <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>{isETRIGPNITRV5FeatureEnabled ? <span>Record surrender was unsuccessful</span> : <span>Surrender was unsuccessful</span>}</span>
                        </div>
                    </div>)
                );
            case "surrender_rejected":
                return (
                    <div className="tooltip">
                        <ETRExclamationTriangle />
                        <div className="tooltiptext eform-tooltip-text">
                            <span>{isETRIGPNITRV5FeatureEnabled ? <span>Record surrender was denied</span> : <span>Surrender was denied</span>}</span>
                        </div>
                    </div>
                );
            default:
                return;
        }
    }

    // View Transaction Details
    function onViewDetailBtnClick(id) {
        return goTo(`/record-transfer/record-details/${id}`)
    }

    // Update and Delete Transaction
    async function updateSelectedTransaction() {
        const body = {
            name: name
        }
        setLoading(true);
        const [error] = await api.updateRecordTransferableDetails(selectedTransferableRecordId, body);

        if (error) {
            setLoading(false);
            return setError(error.message || "Failed to Update ETR Transaction")
        }

        setLoading(false);
        hideUpdateTransactionModal();
        addToastMessage("ETR Transaction updated successfully", 'success')
        refetchData();
    }

    // Delete Selected Transactions
    async function deleteSelectedTransactions() {
        setLoading(true);
        const selectedItems = updatedData.filter(field => field.$selected === true).map(field => field.transferableRecordId);
        const body = {
            transferableDocumentIDs: selectedItems
        }

        const [error] = await api.deleteMultipleRecordsETR(body);
        if (error) {
            setLoading(false);
            return setError(error.message || "Failed to Delete ETR Transactions")
        }

        setLoading(false);
        addToastMessage("ETR Transactions deleted successfully", 'success')
        refetchData();
    }

    async function deleteSelectedTransaction() {
        setLoading(true);
        const [error] = await api.deleteRecordTransferableDetails(selectedTransferableRecordId);

        if (error) {
            setLoading(false);
            return setError(error.message || "Failed to Delete ETR Transaction")
        }

        setLoading(false);
        hideDeleteTransactionModal();
        addToastMessage("ETR Transaction deleted successfully", 'success')
        refetchData();
    }

    async function checkOrgHasTermClauses() {
        setLoading(true);
        const [error, data] = await api.checkOrgHasTermClause(profile.organizationId);

        if (error) {
            setLoading(false);
            addToastMessage("Failed to check model terms associated to org", toastType.error);
            return null;
        }

        setLoading(false);
        return data;
    }

    function isAllCheck() {
        return updatedData.every(field => field.$selected === true)
    }

    function changeListCheckboxes(value) {
        const index = updatedData.findIndex(field => field.transferableRecordId === value);
        const updatedItem = produce(updatedData, draft => {
            draft[index].$selected = !draft[index].$selected
        })
        setUpdatedData(updatedItem);
    }

    function changeAllListCheckbox(event) {
        if (event.target.checked) {
            const updatedItems = updatedData.map(field => ({ ...field, $selected: true }))
            return setUpdatedData(updatedItems)
        }

        const updatedItem = updatedData.map(field => ({ ...field, $selected: false }))
        setUpdatedData(updatedItem)
    }

    function openExistingETRTransaction(transferableRecordId) {
        return goTo(`/record-transfer/record-details/${transferableRecordId}`)
    }

    function getETRStatuses({ isListView, status, eventStatus }) {
        const { component } = GetETRMakerCheckerStatus({
            isListView,
            status,
            eventStatus
        });
        return component;
    }

    async function fetchAndRedirect() {
        const result = await checkOrgHasTermClauses();
        if (!result) return;

        result.hasTermClause ? goTo("/record-transfer/share", { type: "new", hasTermClause: result.hasTermClause }) : showIssuanceNotAllowedModal();
    }


    // List of ETR Issuance
    const list = updatedData?.map((item, index) => {
        return (
            <div className="data-table__table__body__row" key={index + 1}>
                <div className="data-table__table__body__content data-table__table__body__content--checkbox">
                    <label className={"data-table__table__body__content--etrmc_checkbox etr-issuance__checkbox-content"} htmlFor={item.transferableRecordId} data-testid="eform-checkbox-clicked">
                        <input
                            type="checkbox"
                            name={item.name}
                            id={item.transferableRecordId}
                            value={item.transferableRecordId}
                            checked={item.$selected}
                            onChange={(e) => changeListCheckboxes(item.transferableRecordId)}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
                <div className="data-table__table__body__row-cursor" data-testid="view-transactions-details"
                    onClick={() => { onViewDetailBtnClick(item.transferableRecordId) }} onKeyDown={() => { onViewDetailBtnClick(item.transferableRecordId) }}
                    role="none">
                    <div className={`data-table__table__body__content etr-issuance-data-table__table__body__content-filename etr-issuance__data-table-draft`} data-testid="tt-file-name">
                        {getETRMakerCheckerEventStatus(item.status.toLowerCase(), item.eventStatus?.toLowerCase())}
                        {item?.name ?? "-"}
                    </div>
                    {<div className="data-table__table__body__content etr-issuance-data-table__table__body__content-status" data-testid="tt-status-mc">
                        {getETRStatuses({ isListView: true, status: item?.status?.toLowerCase(), eventStatus: item?.eventStatus?.toLowerCase() })}
                    </div>}
                    <div
                        className={`data-table__table__body__content etr-issuance-data-table__table__body__content-issuername`}
                        data-testid="tt-issuer"
                    >
                        <div>{item.issuer?.name ?? "-"}</div>
                    </div>
                    <div
                        className={`data-table__table__body__content etr-issuance-data-table__table__body__content-text`}
                        data-testid="tt-document-type"
                    >
                        {item.type === "TRANSFERABLE" ? "ETR" : "Verifiable Document"}
                    </div>
                    <div className="data-table__table__body__content etr-issuance-data-table__table__body__content-text" data-testid="tt-created-date">
                        <div>{moment(item.created).format("DD/MM/YYYY")}</div>
                        <div>{moment(item.created).format("h:mm A")}</div>
                    </div>
                </div>
                <div
                    className={`etr-issuance-data-table__table__body__content-action`}
                    data-testid={`${item.transferableRecordId}-tt-actions`}
                >
                    <MultiLevelDropDown
                        menuList={[
                            {
                                label: "Edit",
                                onClick: (e) => {
                                    e.stopPropagation();
                                    setSelectedTransferableRecordId(item.transferableRecordId);
                                    setName(item.name);
                                    showUpdateTransactionModal();
                                },
                            },
                            !item?.eventStatus?.includes("PENDING_APPROVAL") && {
                                label: "Delete",
                                onClick: (e) => {
                                    e.stopPropagation();
                                    setSelectedTransferableRecordId(item.transferableRecordId);
                                    showDeleteTransactionModal();
                                },
                            },
                        ]}
                    />
                </div>
            </div>
        );
    });

    // Pagination Events
    function goToPrev() {
        if (currentPage === 1) {
            return
        }

        setCurrentPage(prev => prev - 1)
    }

    function goToNext() {
        if (currentPage === meta?.totalPages) {
            return
        }

        setCurrentPage(prev => prev + 1)
    }

    const onDropRejected = useCallback((_rejectedFiles) => {
        setError("Unsupported file format. Please upload an ETR file in a supported format (e.g., .tt).");
        showInvalidErrorModal();
    }, []);

    const onDrop = useCallback((acceptedFiles) => {
        const ttFileUploaded = acceptedFiles.map((file) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
            })
        );

        // File size validation, 250MB limit
        if (ttFileUploaded?.[0]?.size > 250000000) {
            setError("Your file exceeds the maximum allowed size. Please reduce the file size to 250MB and try again.");
            showInvalidErrorModal();
            return;
        }
        setFiles(ttFileUploaded);
    }, []);

    useEffect(async () => {
        if (files.length > 0) {
            setLoading(true);
            const [error, response] = await api.uploadTTFile(files[0]);
            setLoading(false);
            setMouseDragActive(false);
            setFiles([]);
            if (error) {
                if (error?.message.includes("timeout")) {
                    return setError("Network error detected. Please check your connection and try to upload your ETR file again.");
                } else {
                    return setError(error?.error?.message || error?.message || "This TradeTrust (.tt) file is not an E-Transferable Record. Please upload a valid TradeTrust file.");
                }
            } else {
                if (response.file_content) {
                    addToastMessage("File uploaded successfully", toastType.success);
                    refetchData();
                }
                else {
                    setETRExistingDetails(response);
                    showInvalidFileUpload();
                }
            }
        }
    }, [files]);

    const onDragEnter = () => setMouseDragActive(true);
    const onDragLeave = () => setMouseDragActive(false);

    const { getRootProps, getInputProps, isDragActive, open } = useDropzone({ onDrop, onDropRejected, onDragLeave, onDragEnter, multiple: false, accept: ".tt", noClick: true });

    useEffect(() => {
        const handleDragEnd = () => setMouseDragActive(false);
        const handleDragLeave = (event) => {
            if (!event.target.closest(".etr-issuance-record-data")) {
                setMouseDragActive(false);
            }
        };

        window.addEventListener("dragend", handleDragEnd);
        window.addEventListener("dragleave", handleDragLeave);

        return () => {
            window.removeEventListener("dragend", handleDragEnd);
            window.removeEventListener("dragleave", handleDragLeave);
        };
    }, []);

    const roleGuard = (profile, allowedRoles = ["MAKER", "CHECKER"]) => {

        const { organization: { makerChecker } = {}, makerCheckerRole } = profile || {};

        return !makerChecker || (makerChecker && allowedRoles.includes(makerCheckerRole));
    };

    return (
        <>
            <div
                className="etr-issuance-record-data"
                {...getRootProps()}
            >
                {roleGuard(profile) && isDragActive && mouseDragActive && (
                    <div className="etr-issuance-record-data-overlay">
                        <IconFileUpload />
                        <span className="etr-issuance-record-data-overlay-text">Drop your TradeTrust file here to upload.</span>
                    </div>
                )}
                <div className="etr-issuance-record-list">
                    <div className="etr-issuance-record-list-flex">
                        <div className="data-table__table__head__row__search">
                            <div className="etr-issuance-record-list__head__title" style={{ maxWidth: rem(550) }}>
                                <div style={{ width: "350px" }}>
                                    <Search
                                        value={displayedSearchText}
                                        placeholder={"Search"}
                                        onChange={(e) => {
                                            setDisplayedSearchText(e.target.value);
                                            handleSearch(e.target.value);
                                        }}
                                        onCancel={() => {
                                            setDisplayedSearchText('')
                                            handleSearch('')
                                        }}
                                    />
                                </div>

                                <div className="icon-adjustment_filter">
                                    <ETRFilterDropDown
                                        resetFilter={resetFilter}
                                        filter={filter}
                                        setFilter={setFilter}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="etr-issuance-record-list__head__title">
                            {ETRDataElements?.length > 0 && contracts?.length > 0 && (<>
                                {(roleGuard(profile, ["MAKER"])) &&
                                    <Button
                                        text={"Issue New ETR"}
                                        maxWidth="140"
                                        full
                                        round
                                        noborder
                                        noHover
                                        submit={async () => {
                                            if (isETRLegalRequirementsEnabled) {
                                                await fetchAndRedirect();
                                            } else {
                                                goTo("/record-transfer/share", {
                                                    type: "new",
                                                });

                                            }
                                        }}
                                    />
                                }
                                <span
                                    style={{
                                        width: rem(10),
                                        display: "inline-block",
                                    }}
                                />
                            </>
                            )}
                            {(roleGuard(profile)) && <div
                                {...getRootProps({
                                    onDrop: (event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                    },
                                })}
                            >
                                <Button
                                    text={"Upload ETR"}
                                    maxWidth="140"
                                    full
                                    round
                                    submit={open}
                                />
                                <input
                                    type="file"
                                    className="hidden"
                                    id={`input-file`}
                                    data-testid="eform-input-fileupload"
                                    {...getInputProps()}
                                ></input>
                            </div>}
                        </div>
                    </div>
                    <div className="etr-issuance-record-list-tip-flex">
                        <div className="etr-data-element-payload-heading-details-left">
                            <IconInfoCircle />
                            <div className="etr-issuance-record-list-tip-details">
                                Tip: You may also drop your TradeTrust file in
                                this table to upload new ETR.
                            </div>
                        </div>
                    </div>
                    <div className="data-table3__header">
                        <FilterApplied
                            filter={filter}
                            setFilter={setFilter}
                        />
                    </div>
                    {selectedItemsCount.length > 0 && (
                        <div className="etr-issuance-record-list-tip-flex">
                            <div className="etr-data-element-payload-heading-details-left">
                                <span className="etr-issuance-record-list-tip-details">{selectedItemsCount.length} Files Selected</span>
                                <span onClick={() => deleteSelectedTransactions()} onKeyDown={() => deleteSelectedTransactions()}
                                    role="none" className="etr-issuance-record-list-delete-selection" data-testid="delete-all-transaction-id">Delete Selection</span>
                            </div>
                        </div>
                    )}
                </div>
                <div>
                    <div className="data-table__table__body">
                        {updatedData?.length > 0 ? (
                            <div>
                                <div className="data-table__table__head__row">
                                    <div className="data-table__table__head__title data-table__table__head__title--checkbox">
                                        {
                                            <label className={"data-table__table__body__content--etrmc_checkbox"}>
                                                <input
                                                    type="checkbox"
                                                    name="All"
                                                    id="AllCheckbox"
                                                    checked={isAllCheck()}
                                                    onChange={(e) =>
                                                        changeAllListCheckbox(e)
                                                    }
                                                />
                                                <span className="checkmark" data-testid="datatable-checkbox-all" />
                                            </label>
                                        }
                                    </div>

                                    <div className="data-table__table__body__row-cursor">
                                        <div
                                            className={`data-table__table__head__title data-table__table__head__title__sort-order etr-issuance-data-table__table__head__title-filename link ${getClassName(
                                                "name"
                                            )}`}
                                            onClick={() => handleSort('name')} onKeyDown={() => handleSort('name')}
                                            id="name"
                                            role="none"
                                        >
                                            <div>TradeTrust File</div>
                                            {<div className="etr-maker-checker-btn-group">
                                                <button className="data-table__table__head__icon__sort-order-up">
                                                    <IconChevronDown />
                                                </button>
                                                <button className="data-table__table__head__icon__sort-order-down">
                                                    <IconChevronDown />
                                                </button>
                                            </div>}
                                        </div>
                                        {<div
                                            className={`data-table__table__head__title data-table__table__head__title__sort-order etr-issuance-data-table__table__head__title-status link ${getClassName(
                                                "status"
                                            )}`}
                                            onClick={() => handleSort('status')} onKeyDown={() => handleSort('status')}
                                            id="status"
                                            role="none"
                                        >
                                            <div>Status</div>
                                            <div className="etr-maker-checker-btn-group">
                                                <button className="data-table__table__head__icon__sort-order-up">
                                                    <IconChevronDown />
                                                </button>
                                                <button className="data-table__table__head__icon__sort-order-down">
                                                    <IconChevronDown />
                                                </button>
                                            </div>
                                        </div>}
                                        <div
                                            className={`data-table__table__head__title data-table__table__head__title__sort-order etr-issuance-data-table__table__head__title-issuername link ${getClassName(
                                                "issuer"
                                            )}`}
                                            onClick={() => handleSort('issuer')} onKeyDown={() => handleSort('issuer')}
                                            id="issuer"
                                            role="none"
                                        >
                                            <div>Issuer</div>
                                            {<div className="etr-maker-checker-btn-group">
                                                <button className="data-table__table__head__icon__sort-order-up">
                                                    <IconChevronDown />
                                                </button>
                                                <button className="data-table__table__head__icon__sort-order-down">
                                                    <IconChevronDown />
                                                </button>
                                            </div>}
                                        </div>
                                        <div
                                            className={`data-table__table__head__title data-table__table__head__title__sort-order etr-issuance-data-table__table__head__title-text link ${getClassName(
                                                "type"
                                            )}`}
                                            onClick={() => handleSort('type')} onKeyDown={() => handleSort('type')}
                                            id="type"
                                            role="none"
                                        >
                                            <div>Document Type</div>
                                            {<div className="etr-maker-checker-btn-group">
                                                <button className="data-table__table__head__icon__sort-order-up">
                                                    <IconChevronDown />
                                                </button>
                                                <button className="data-table__table__head__icon__sort-order-down">
                                                    <IconChevronDown />
                                                </button>
                                            </div>}
                                        </div>
                                        <div
                                            className={`data-table__table__head__title data-table__table__head__title__sort-order etr-issuance-data-table__table__head__title-text link ${getClassName(
                                                "modified"
                                            )}`}
                                            onClick={() => handleSort('modified')} onKeyDown={() => handleSort('modified')}
                                            id="created"
                                            role="none"
                                        >
                                            <div>Date Created</div>
                                            {<div className="etr-maker-checker-btn-group">
                                                <button className="data-table__table__head__icon__sort-order-up">
                                                    <IconChevronDown />
                                                </button>
                                                <button className="data-table__table__head__icon__sort-order-down">
                                                    <IconChevronDown />
                                                </button>
                                            </div>}
                                        </div>
                                    </div>
                                    <div
                                        className={`data-table__table__head__title__sort-order etr-issuance-data-table__table__head__title-action link`}
                                    ></div>
                                </div>
                                {mouseDragActive ? roleGuard(profile) ? null : list : list}
                            </div>
                        ) : (
                            <div className="etr-issuance-no-message-record">
                                <div className="data-table__empty__icon">
                                    <IconNoMessage />
                                    <div>No ETR uploaded or issued yet.</div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {updatedData?.length > 0 && (
                    <div className="data-table__table__body-footer">
                        <div className="data-table__table__footer">
                            <div className="data-table__table__footer__row">
                                <div className="data-table__table__footer__row__left">
                                    <div className="data-table__table__meta">
                                        Showing{" "}
                                        {getPageLabel(
                                            meta?.total,
                                            pageLimit,
                                            currentPage - 1
                                        )}{" "}
                                        of {meta?.total || 0} entries
                                    </div>
                                </div>
                                <div className="data-table__table__footer__row__right">
                                    <div className="data-table__table__pagination">
                                        <input
                                            className={"etr-maker-checker__data-table__table__pagination__page"}
                                            type="number"
                                            value={currentPage}
                                            onChange={(e) => {
                                                setCurrentPage(Number(e.target.value) || 1);
                                            }}
                                            min="1"
                                        />
                                        <span className="data-table__table__pagination__page__meta">
                                            {" "}
                                            of {meta?.totalPages || 1} pages{" "}
                                        </span>
                                        <button
                                            data-testid="pagination-prev"
                                            className={"etr-maker-checker__data-table__table__pagination__prev"}
                                            onClick={() => goToPrev()}
                                        >
                                            <IconChevronDown />
                                        </button>
                                        <button
                                            data-testid="pagination-next"
                                            className={"etr-maker-checker__data-table__table__pagination__next"}
                                            onClick={() => goToNext()}
                                        >
                                            <IconChevronDown />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <Modal visible={updateTransactionModal} variant="medium" close={hideUpdateTransactionModal}>
                <CardConfigure   >
                    <CardConfigure.Header>
                        <CardConfigure.Header.Title>
                            <div className="card-configure__header__left">
                                <div className="card-configure__title">
                                    <div className="card-configure__title__left">
                                        <IconFileNameEdit />
                                    </div>
                                    <div className="card-configure__title__right">
                                        <div className="card-configure__title__right__top">
                                            Rename File
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardConfigure.Header.Title>
                    </CardConfigure.Header>
                    <CardConfigure.Body>
                        <CardConfigure.Body.Col>
                            <div className="eclip-receipient__input">
                                <span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
                                    File Name
                                </span>
                                <input
                                    data-testid="rename-transaction-id-input"
                                    type="text" value={name}
                                    onChange={(e) => {
                                        setName(e.target.value)
                                    }}
                                    placeholder="Enter File Name"
                                />
                            </div>
                        </CardConfigure.Body.Col>
                    </CardConfigure.Body>
                    <CardConfigure.Footer>
                        <CardConfigure.Footer.Left>
                            <Button
                                ghost
                                round
                                noborder
                                nobackground
                                nohover
                                data-testid="rename-transaction-id-cancel"
                                text="Cancel"
                                submit={() => hideUpdateTransactionModal()}
                            />
                        </CardConfigure.Footer.Left>
                        <CardConfigure.Footer.Right>
                            <Button
                                text="Confirm"
                                round
                                data-testid="rename-transaction-id"
                                disabled={name?.trim() === ""}
                                submit={() => updateSelectedTransaction()}
                            />
                        </CardConfigure.Footer.Right>
                    </CardConfigure.Footer>
                </CardConfigure>
            </Modal>

            <Modal visible={deleteTransactionModal} variant="medium" close={hideDeleteTransactionModal}>
                <CardConfigure >
                    <CardConfigure.Header>
                        <CardConfigure.Header.Title>
                            <div className="card-configure__header__left">
                                <div className="card-configure__title">
                                    <div className="card-configure__title__left">
                                        <IconWarningIndicator />
                                    </div>
                                    <div className="card-configure__title__right">
                                        <div className="card-configure__title__right__top">
                                            Delete File
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardConfigure.Header.Title>
                    </CardConfigure.Header>
                    <CardConfigure.Body>
                        <CardConfigure.Body.Col>
                            <div>
                                Are you sure you want to delete file?
                            </div>
                        </CardConfigure.Body.Col>
                    </CardConfigure.Body>
                    <CardConfigure.Footer>
                        <CardConfigure.Footer.Left>
                            <Button
                                ghost
                                round
                                noborder
                                textWarning
                                nobackground
                                nohover
                                data-testid="delete-transaction-id-cancel"
                                text="Cancel"
                                submit={() => hideDeleteTransactionModal()}
                            />
                        </CardConfigure.Footer.Left>
                        <CardConfigure.Footer.Right>
                            <Button data-testid="delete-transaction-id" text="Confirm" round warning warningbackgroundhover submit={() => deleteSelectedTransaction()} />
                        </CardConfigure.Footer.Right>
                    </CardConfigure.Footer>
                </CardConfigure>
            </Modal>

            <Modal visible={invalidErrorModal} variant="medium" close={handleError}>
                <CardConfigure>
                    <CardConfigure.Header>
                        <CardConfigure.Header.Title>
                            <div className="card-configure__header__left">
                                <div className="card-configure__title">
                                    <div className="card-configure__title__left">
                                        <IconWarningIndicator />
                                    </div>
                                    <div className="card-configure__title__right">
                                        <div className="card-configure__title__right__top">
                                            Invalid
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardConfigure.Header.Title>
                    </CardConfigure.Header>
                    <CardConfigure.Body>
                        <CardConfigure.Body.Col>
                            <div>
                                {error}
                            </div>
                        </CardConfigure.Body.Col>
                    </CardConfigure.Body>
                    <CardConfigure.Footer>
                        <CardConfigure.Footer.Right>
                            <Button
                                ghost
                                round
                                text="Cancel"
                                submit={() => handleError()}
                            />
                        </CardConfigure.Footer.Right>
                    </CardConfigure.Footer>
                </CardConfigure>
            </Modal>

            <Modal visible={invalidFileUpload} variant="medium" close={hideInvalidFileUpload}>
                <CardConfigure>
                    <CardConfigure.Header>
                        <CardConfigure.Header.Title>
                            <div className="card-configure__header__left">
                                <div className="card-configure__title">
                                    <div className="card-configure__title__left">
                                        <IconWarningIndicator />
                                    </div>
                                    <div className="card-configure__title__right">
                                        <div className="card-configure__title__right__top">
                                            Duplicate ETR
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardConfigure.Header.Title>
                    </CardConfigure.Header>
                    <CardConfigure.Body>
                        <CardConfigure.Body.Col>
                            <div>
                                {etrExistingDetails?.status?.includes("PENDING_APPROVAL") ?
                                    `This ETR already exists and it's current waiting for checker's approval. Please hold off on any new submissions until the current review is complete. Would you like to view the existing ETR?` :
                                    `This ETR already exists. Would you like to view the existing ETR?`}
                            </div>
                        </CardConfigure.Body.Col>
                    </CardConfigure.Body>
                    <CardConfigure.Footer>
                        <CardConfigure.Footer.Right>
                            <Button
                                ghost
                                round
                                text="Cancel"
                                submit={() => hideInvalidFileUpload()}
                            />
                            <span style={{ width: rem(5), display: 'inline-block' }}></span>
                            <Button
                                round
                                text="Confirm"
                                submit={() => openExistingETRTransaction(etrExistingDetails?.transferableRecordID)}
                            />
                        </CardConfigure.Footer.Right>
                    </CardConfigure.Footer>
                </CardConfigure>
            </Modal>

            {isETRLegalRequirementsEnabled && <Modal visible={issuanceNotAllowdeModal} variant="medium" close={hideIssuanceNotAllowedModal}>
                <CardConfigure>
                    <CardConfigure.Header>
                        <CardConfigure.Header.Title>
                            <div className="card-configure__header__left">
                                <div className="card-configure__title">
                                    <div className="card-configure__title__left">
                                        <IconWarningIndicator />
                                    </div>
                                    <div className="card-configure__title__right">
                                        <div className="card-configure__title__right__top">
                                            Issuance Unavailable
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardConfigure.Header.Title>
                    </CardConfigure.Header>
                    <CardConfigure.Body>
                        <CardConfigure.Body.Col>
                            <div>
                                Issuance is currently unavailable because your organization<br />
                                has not filled eBL Template for ETR yet. Kindly contact your<br />
                                organization’s administrator to proceed.
                            </div>
                        </CardConfigure.Body.Col>
                    </CardConfigure.Body>
                    <CardConfigure.Footer>
                        <CardConfigure.Footer.Right>
                            <Button
                                warning
                                round
                                text="Dismiss"
                                submit={() => hideIssuanceNotAllowedModal()}
                            />
                            <span style={{ width: rem(5), display: 'inline-block' }}></span>
                        </CardConfigure.Footer.Right>
                    </CardConfigure.Footer>
                </CardConfigure>
            </Modal>}

            {
                (loading || etrDocListLoading) && (
                    ReactDOM.createPortal(
                        <div className='modal white'>
                            <div className='loading'>
                                <img src="/loading.gif" alt="loader" />
                            </div>
                        </div>
                        , document.body
                    )
                )
            }

            <Toast autoDelete={true} toastList={toastList} />
        </>
    );
};

ETRIssuanceComponent.propTypes = {
    defaultFileLists: PropTypes.array,
    defaultSelectedItems: PropTypes.array
};

export default ETRIssuanceComponent;
